import styled from 'styled-components/macro'

const Avatar = styled.div`
  background-image: url(${props => props.url});
  background-size: cover;
  background-position: center;
  width: ${props => `${(props.size || 50) / 10}rem`};
  height: ${props => `${(props.size || 50)  / 10}rem`};
  border-radius: 50%;
`

export default Avatar